<template>
  <div class="city">
    <span class="col id">{{city.id}}</span>
    <a href="#" to="/cities/:city.id" v-on:click="showCity" class="col cityname">{{city.city}}</a>
    <span class="col land">{{city.land}}</span>
    <span class="col telephone"><input :class="status" v-model="city.telefon" v-on:focus="saveOldVal" v-on:blur="telefonblur"><i></i></span>
  </div>
</template>
<script>
export default {
  name: "City",
  props: ['city'],
    data() {
        return {
          status: "",
        }
    },
/*
  watch: {
    'city.telefon' : {
          handler: function(val, oldVal){ alert('tel changed from '+oldVal+' to ' + val); }
        },
  }, 
*/   
/*
  sockets: {
    citySaveValue(o){
      console.log( 'incoming m');
      if(o.id == this.id) { this.status = 'saved' }
    }
  },
*/
  methods: {
    saveOldVal(){
      this.city.telefonold = this.city.telefon
      this.status = 'focus';
      
    },
    telefonblur(){
      this.status = '';
      if( this.city.telefonold != this.city.telefon ) this.citySaveTelefon()
    },
    
    update(e){
      //console.log("changed form " + this.city.telefonold + " to " + this.city.telefon );
    },
    showCity(e){
      e.preventDefault();
      this.$router.replace({ name: "CitySingle", params: {cityid: this.city.id } })
    },
    
    citySaveTelefon( field, value, valueBefore ){
      this.status = 'saving';
      this.$socket.emit('citySaveValue', { update: { id: this.city.id, field: 'telefon', oldValue: this.city.telefonold, value: this.city.telefon }, quiet: 1 } );      
      setTimeout( ()=>{ this.status = "saved" }, 1000 )
    },
    
  }
}
</script>
<style>
  .city {}
  .city .land { text-transform: uppercase; }
  .city .col.telephone { display: flex; }
  .city .col.telephone input { display: block }
  .city .telephone input + i { display: block; background: none; background-size: contain; color: red !important; vertical-align: top; text-align: center; font-size: 1em; width: 2em; height: 1.7em; content:"O"; text-indent: 0; padding: 0 !important; }
  .city .telephone input.focus + i { display: block; background: url(../../assets/img/circles-menu-1.gif) center center no-repeat; background-size: contain; color: red !important; vertical-align: top; text-align: center; font-size: 1em; width: 2em; height: 1.7em; content:"O"; text-indent: 0; padding: 0 !important; }
  .city .telephone input.saving + i { display: block; background: url(../../assets/img/running-circle-2.gif) center center no-repeat; background-size: contain; color: red !important; vertical-align: top; text-align: center; font-size: 1em; width: 2em; height: 1.7em; content:"O"; text-indent: 0; padding: 0 !important; }
  .city .telephone input.saved + i { display: block; background: url(../../assets/img/check-green.png) center center no-repeat; background-size: contain; color: red !important; vertical-align: top; text-align: center; font-size: 1em; width: 2em; height: 1.7em; content:"O"; text-indent: 0; padding: 0 !important; }
</style>